export default __webpack_public_path__ + "74c15750742e9f8eacba33e503cbbafe.svg";